import loadable from '@loadable/component';

export { default as SearchMap } from './SearchMap';
export { default } from './SearchMap';
export const Map = loadable(
	() => import(/* webpackChunkName: "Map" */ './Map'),
);
